module.exports = __webpack_public_path__ + "img/icon_heart_rate_inactive.e3501616.svg";